/**
 * PDV-CAMPO-PAGAMENTO (I.160, decisão 5 do Diretor, 24/10: "1.000" = mil reais em todos os campos de valor, com teste).
 * Lê o que a pessoa digitou (ou o texto formatado "R$ 1.000,00") e devolve o número em reais, com 2 casas.
 * - Só ponto, em grupos de milhar ("1.000", "12.345", "1.000.000"; parte inteira sem zero à esquerda): ponto é milhar.
 * - Com vírgula, ou ponto fora desse formato ("20.50", "1.5", "0.500"): o ÚLTIMO separador (vírgula ou ponto) é o decimal
 *   e os outros são milhar ("1.000,50" e "1,000.50" = 1.000,50; "20,50" = 20,50).
 * - Qualquer outro caractere (R$, espaço) é ignorado; vazio = 0.
 */
export function parseMoneyInput(raw: string | null | undefined): number {
  const cleaned = (raw ?? '').replace(/[^\d.,]/g, '');
  if (!cleaned || !/\d/.test(cleaned)) return 0;

  let normalized: string;
  if (/^[1-9]\d{0,2}(\.\d{3})+$/.test(cleaned)) {
    normalized = cleaned.replace(/\./g, '');
  } else {
    const lastSep = Math.max(cleaned.lastIndexOf(','), cleaned.lastIndexOf('.'));
    if (lastSep === -1) {
      normalized = cleaned;
    } else {
      const intPart = cleaned.slice(0, lastSep).replace(/[.,]/g, '');
      const decPart = cleaned.slice(lastSep + 1).replace(/[.,]/g, '');
      normalized = `${intPart || '0'}.${decPart || '0'}`;
    }
  }

  const value = Number(normalized);
  return Number.isFinite(value) ? Math.round(value * 100) / 100 : 0;
}
